// Initialize jQuery and BootstrapJS.
import '@/bootstrap'

// Initialize application.
import { AppConfig } from '@/libs'
import '@/icons'
import Vue from 'vue'
import App from '@/App'
import store from '@/store'
import router from '@/router'

// Initialize libraries.
import _ from 'lodash'
import Big from 'big.js'
import moment from 'moment'

// Initialize directives.
import { Cleave, Tooltip } from './directives'

// Initialize plugins.
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import VueLocalStorage from 'vue-localstorage'

import {
  App as AppPlugin,
  Collection,
  Crm,
  Dates,
  Dialog,
  Document,
  Flash,
  Formatting,
  Id,
  Investment,
  Modal,
  Pdf,
  Project,
  Role,
  Window
} from './plugins'
import { Auth0Plugin } from './stores/core/lib/Auth0'

Vue.config.productionTip = false

Object.defineProperty(Vue.prototype, '$_', { value: _ })
Object.defineProperty(Vue.prototype, '$big', { value: Big })
Object.defineProperty(Vue.prototype, '$moment', { value: moment })

AppConfig.load().then(() => {
  Vue.use(Cleave)
  Vue.use(Tooltip)

  Vue.use(VueRouter)
  Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
  })
  Vue.use(VueLocalStorage)

  Vue.use(AppPlugin)
  Vue.use(Collection)
  Vue.use(Crm)
  Vue.use(Dates)
  Vue.use(Dialog)
  Vue.use(Document)
  Vue.use(Flash)
  Vue.use(Formatting)
  Vue.use(Id)
  Vue.use(Investment)
  Vue.use(Modal)
  Vue.use(Pdf)
  Vue.use(Project)
  Vue.use(Role)
  Vue.use(Window)

  Vue.use(Auth0Plugin, {
    domain: AppConfig.get('auth0_domain'),
    client_id: AppConfig.get('auth0_client_id'),
    onRedirectCallback: appState => {
      router.push(
        appState && appState.targetUrl ? appState.targetUrl : window.location.pathname
      )
    }
  })

  // Auto require base components.
  const requireComponent = require.context(
    // The relative path of the components folder
    './components',
    // Whether or not to look in subfolders
    false,
    // The regular expression used to match base component filenames
    /Base[A-Z]\w+\.(vue|js)$/
  )

  requireComponent.keys().forEach(fileName => {
    // Get component config
    const componentConfig = requireComponent(fileName)

    // Get PascalCase name of component
    const componentName = _.upperFirst(
      _.camelCase(
        // Gets the file name regardless of folder depth
        fileName
          .split('/')
          .pop()
          .replace(/\.\w+$/, '')
      )
    )

    // Register component globally
    Vue.component(
      componentName,
      // Look for the component options on `.default`, which will
      // exist if the component was exported with `export default`,
      // otherwise fall back to module's root.
      componentConfig.default || componentConfig
    )
  })

  new Vue({
    metaInfo: {
      titleTemplate: title => {
        return (title ? `${title} - ` : '') + 'Saxon Trust'
      }
    },
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
